export default "__VITE_PUBLIC_ASSET__bffa1bc4__"